import { Panel } from "../layout/Panel.tsx";
import { RiveGauge } from "../viz/RiveGauge.tsx";
import { metrics } from "../../stores/metrics.ts";

const NR_BROWSER = "https://one.newrelic.com/redirect/entity/MTg3NzkxMXxCUk9XU0VSfEFQUExJQ0FUSU9OfDEzODYwOTE2MTI";

export function WebVitalsPanel() {
  const get = (m: string) => metrics.latest[`newrelic-browser:${m}`]?.value ?? 0;
  return (
    <Panel title="Web Vitals · NR Browser" href={NR_BROWSER} span="col-span-4">
      <div class="grid grid-cols-3 gap-3">
        <RiveGauge label="LCP" value={get("lcp_seconds")} max={4} unit="s" />
        <RiveGauge label="CLS" value={get("cls")} max={0.25} />
        <RiveGauge label="INP" value={get("inp_ms")} max={500} unit="ms" />
      </div>
    </Panel>
  );
}
